import { CommonModule } from '@angular/common';
import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { UiService } from 'src/app/services/ui.service';

@Component({
    selector: 'label-tier',
    template: `
<div class="label-tier">
  <div class="lbl" *ngFor="let id of labels" [ngStyle]="{background: assoc_template[id]?.color}" [hidden]="!assoc_template[id]">{{assoc_template[id]?.label}}</div>
</div>
  `,
    styles: [`
  .label-tier { display: flex; flex-wrap: wrap; }
  .label-tier .lbl {
      min-width: 40px; height: 15px; line-height: 15px; border-radius: 2px; padding: 0 3px;
      font-size: 11px; font-weight: bold; margin: 2px 5px 2px 0; color: #fff; max-width: 25vw;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;
  }
  `],
    styleUrls: ['./label-marker.component.scss'],
    standalone: true,
    imports: [CommonModule],
})


export class LabelTierDialogComponent implements OnInit, OnChanges {
  @Input() labels = [];
  @Input() template;
  assoc_template: any;
  constructor(private ui: UiService) {}

// todo: make all calles to label-tier use an async selector so you dont have to
// 1) test for array
// 2) have a backup default list
// 3) use ngOnChanges

  ngOnInit() {
      this.assoc_template = {};
      if (this.template) {
        if(Array.isArray(this.template)){
          this.template.forEach(label => this.assoc_template[label.id] = label);
        }else{
          this.assoc_template = this.template
        }
      } else {
          this.ui.defaultLabels.forEach(label => this.assoc_template[label.id] = label);
      }
  }
  ngOnChanges(changes) {
      // console.log('tier changes', changes)
      if (changes.template && changes.template.currentValue) {
          if(Array.isArray(changes.template.currentValue)){
            this.assoc_template = {};
            changes.template.currentValue.forEach(label => this.assoc_template[label.id] = label);
          }
      }
  }
}
